import React from 'react';
import DirectionsWalk from '@mui/icons-material/DirectionsWalk';
import DirectionsRun from '@mui/icons-material/DirectionsRun';
import RouteOutlined from '@mui/icons-material/RouteOutlined';
import LocalFireDepartmentOutlined from '@mui/icons-material/LocalFireDepartmentOutlined';
import TimerOutlined from '@mui/icons-material/TimerOutlined';
import BoltOutlined from '@mui/icons-material/BoltOutlined';
import TerrainOutlined from '@mui/icons-material/TerrainOutlined';
import StairsOutlined from '@mui/icons-material/StairsOutlined';
import FitnessCenter from '@mui/icons-material/FitnessCenter';
import Air from '@mui/icons-material/Air';
import WeekendOutlined from '@mui/icons-material/WeekendOutlined';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import MonitorHeartOutlined from '@mui/icons-material/MonitorHeartOutlined';
import Tune from '@mui/icons-material/Tune';
import Timelapse from '@mui/icons-material/Timelapse';
import BloodtypeOutlined from '@mui/icons-material/BloodtypeOutlined';
import BedtimeOutlined from '@mui/icons-material/BedtimeOutlined';
import MonitorWeightOutlined from '@mui/icons-material/MonitorWeightOutlined';
import Height from '@mui/icons-material/Height';
import Percent from '@mui/icons-material/Percent';
import Thermostat from '@mui/icons-material/Thermostat';
import WaterDropOutlined from '@mui/icons-material/WaterDropOutlined';
import Restaurant from '@mui/icons-material/Restaurant';
import GridView from '@mui/icons-material/GridView';
import { SvgIconComponent } from '@mui/icons-material';
import type { MetricInput } from '../../collection/metrics/types';
import { metricPresentation } from './presentation';

const icons: Record<string, SvgIconComponent> = {
  steps: DirectionsWalk, distance: RouteOutlined, 'total-calories': LocalFireDepartmentOutlined,
  'active-energy-burned': LocalFireDepartmentOutlined, 'active-minutes': TimerOutlined,
  'active-zone-minutes': BoltOutlined, 'activity-level': DirectionsRun, altitude: TerrainOutlined,
  floors: StairsOutlined, exercise: FitnessCenter, 'daily-vo2-max': Air, 'run-vo2-max': Air,
  'vo2-max': Air, 'sedentary-period': WeekendOutlined, 'heart-rate': FavoriteBorder,
  'daily-resting-heart-rate': FavoriteBorder, 'daily-heart-rate-variability': MonitorHeartOutlined,
  'heart-rate-variability': MonitorHeartOutlined, 'daily-heart-rate-zones': Tune,
  'time-in-heart-rate-zone': Timelapse, 'calories-in-heart-rate-zone': LocalFireDepartmentOutlined,
  'daily-oxygen-saturation': BloodtypeOutlined, 'oxygen-saturation': BloodtypeOutlined,
  'daily-respiratory-rate': Air, 'respiratory-rate-sleep-summary': Air,
  'daily-sleep-temperature-derivations': Thermostat, 'irregular-rhythm-notification': MonitorHeartOutlined,
  sleep: BedtimeOutlined, weight: MonitorWeightOutlined, height: Height, 'body-fat': Percent,
  'core-body-temperature': Thermostat, 'blood-glucose': BloodtypeOutlined,
  'hydration-log': WaterDropOutlined, 'nutrition-log': Restaurant,
};

export default function FitbitMetricIcon({ metric }: { metric: MetricInput }) {
  const Icon = icons[metric.dataType] || GridView;
  return <Icon aria-hidden="true" sx={{ fontSize: 20, flexShrink: 0, color: metricPresentation(metric).color }} />;
}
